import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import LoadingSpinner from 'components/LoadingSpinner';
import Button from 'components/V2/Button';
import PropTypes from 'prop-types';

import classes from './listingsModal.module.css';

const Footer = ({
    infoText,
    infoTextClassName,
    primaryBtnProps,
    secondaryBtnProps,
    showLoader = false,
}) => {
    return (
        <Box className={classes.footerWrapper}>
            <Box className={classes.footer}>
                <Typography className={clsx(classes.infoText, infoTextClassName)}>
                    {infoText}
                </Typography>
                <Box className={classes.footerBtnWrapper}>
                    <Button intent="secondary" {...secondaryBtnProps}>
                        {secondaryBtnProps.title}
                    </Button>
                    <Button intent="primary" {...primaryBtnProps}>
                        {primaryBtnProps.title}
                        {showLoader && (
                            <LoadingSpinner text={null} spinnerClassName={classes.spinner} />
                        )}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

Footer.propTypes = {
    infoText: PropTypes.string,
    infoTextClassName: PropTypes.string,
    primaryBtnProps: PropTypes.object,
    secondaryBtnProps: PropTypes.object,
    showLoader: PropTypes.bool,
};

export default Footer;
